import React, { Component } from 'react';
import moment from 'moment';

import CheckingOffensesModel from './CheckingOffensesModel';

import { message } from 'antd';

class CheckingOffenseFormImage extends Component {

    state = {
        imgData: null
    }

    async componentWillMount() {
        if (this.props.fileName) {
            try {
                let base64Data = await CheckingOffensesModel.getAttachment(this.props.fileName);
                this.setState({
                    imgData: base64Data
                });
            } catch (err) {
                message.error("Obrázek se nepodařilo načíst!");
            }
        }
    }

    render() {
        if (this.state.imgData) {
            return <img
                alt={this.props.fileName}
                src={"data:image/jpeg;base64," + this.state.imgData} />
        } else {
            return <div></div>
        }
    }
}

export default CheckingOffenseFormImage;


// WEBPACK FOOTER //
// ./src/components/CheckingOffenseFormImage.js